/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_LIST
 */
export const listOpportunityTemplatesQueryPageDefault = 1;export const listOpportunityTemplatesQueryPageSizeDefault = 25;

export const listOpportunityTemplatesQueryParams = zod.object({
  "page": zod.number().default(listOpportunityTemplatesQueryPageDefault),
  "pageSize": zod.number().default(listOpportunityTemplatesQueryPageSizeDefault)
})



export const listOpportunityTemplatesResponseItemsItemPayRateValueMin = 0;
export const listOpportunityTemplatesResponseItemsItemPayRateValueMax = 10000;

export const listOpportunityTemplatesResponseItemsItemAddressAddressLine1Max = 255;

export const listOpportunityTemplatesResponseItemsItemAddressAddressLine2Max = 255;

export const listOpportunityTemplatesResponseItemsItemAddressCityMax = 255;

export const listOpportunityTemplatesResponseItemsItemAddressStateMax = 2;

export const listOpportunityTemplatesResponseItemsItemAddressZipMax = 10;

export const listOpportunityTemplatesResponseItemsItemAddressCountryMax = 100;



export const listOpportunityTemplatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid().nullish(),
  "scope": zod.enum(['System', 'Organization', 'Community']),
  "templateName": zod.string().min(1),
  "title": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(listOpportunityTemplatesResponseItemsItemPayRateValueMin).max(listOpportunityTemplatesResponseItemsItemPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(listOpportunityTemplatesResponseItemsItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listOpportunityTemplatesResponseItemsItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listOpportunityTemplatesResponseItemsItemAddressCityMax).nullish(),
  "state": zod.string().max(listOpportunityTemplatesResponseItemsItemAddressStateMax).nullish(),
  "zip": zod.string().max(listOpportunityTemplatesResponseItemsItemAddressZipMax).nullish(),
  "country": zod.string().max(listOpportunityTemplatesResponseItemsItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_CREATE
 */
export const createOpportunityTemplateBodyTemplateNameMax = 255;

export const createOpportunityTemplateBodyTitleMax = 255;

export const createOpportunityTemplateBodyReferenceRequirementsItemLabelMax = 100;

export const createOpportunityTemplateBodyReferenceRequirementsItemHintMax = 255;

export const createOpportunityTemplateBodyReferenceRequirementsItemExampleMax = 100;

export const createOpportunityTemplateBodyPayRateValueMin = 0;
export const createOpportunityTemplateBodyPayRateValueMax = 10000;

export const createOpportunityTemplateBodyNumberOfUnitsMax = 2147483647;

export const createOpportunityTemplateBodyMaxUnitsPerParticipantMax = 2147483647;

export const createOpportunityTemplateBodyMaxClaimsPerParticipantMax = 2147483647;

export const createOpportunityTemplateBodyMaxClaimsPerRosterMax = 2147483647;

export const createOpportunityTemplateBodyAddressAddressLine1Max = 255;

export const createOpportunityTemplateBodyAddressAddressLine2Max = 255;

export const createOpportunityTemplateBodyAddressCityMax = 255;

export const createOpportunityTemplateBodyAddressStateMax = 2;

export const createOpportunityTemplateBodyAddressZipMax = 10;

export const createOpportunityTemplateBodyAddressCountryMax = 100;

export const createOpportunityTemplateBodyUrlMax = 2048;



export const createOpportunityTemplateBody = zod.object({
  "templateName": zod.string().min(1).max(createOpportunityTemplateBodyTemplateNameMax),
  "title": zod.string().max(createOpportunityTemplateBodyTitleMax).nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "label": zod.string().min(1).max(createOpportunityTemplateBodyReferenceRequirementsItemLabelMax),
  "masks": zod.array(zod.string()).nullish(),
  "hint": zod.string().max(createOpportunityTemplateBodyReferenceRequirementsItemHintMax).nullish(),
  "example": zod.string().max(createOpportunityTemplateBodyReferenceRequirementsItemExampleMax).nullish()
})).nullish(),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(createOpportunityTemplateBodyPayRateValueMin).max(createOpportunityTemplateBodyPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().min(1).max(createOpportunityTemplateBodyNumberOfUnitsMax).nullish(),
  "maxUnitsPerParticipant": zod.number().min(1).max(createOpportunityTemplateBodyMaxUnitsPerParticipantMax).nullish(),
  "maxClaimsPerParticipant": zod.number().min(1).max(createOpportunityTemplateBodyMaxClaimsPerParticipantMax).nullish(),
  "maxClaimsPerRoster": zod.number().min(1).max(createOpportunityTemplateBodyMaxClaimsPerRosterMax).nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(createOpportunityTemplateBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(createOpportunityTemplateBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(createOpportunityTemplateBodyAddressCityMax).nullish(),
  "state": zod.string().max(createOpportunityTemplateBodyAddressStateMax).nullish(),
  "zip": zod.string().max(createOpportunityTemplateBodyAddressZipMax).nullish(),
  "country": zod.string().max(createOpportunityTemplateBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().max(createOpportunityTemplateBodyUrlMax).nullish(),
  "isActive": zod.boolean()
})

export const listSystemTemplatesQueryPageDefault = 1;export const listSystemTemplatesQueryPageSizeDefault = 50;

export const listSystemTemplatesQueryParams = zod.object({
  "page": zod.number().default(listSystemTemplatesQueryPageDefault),
  "pageSize": zod.number().default(listSystemTemplatesQueryPageSizeDefault),
  "isActive": zod.boolean().optional(),
  "search": zod.string().optional()
})



export const listSystemTemplatesResponseItemsItemPayRateValueMin = 0;
export const listSystemTemplatesResponseItemsItemPayRateValueMax = 10000;

export const listSystemTemplatesResponseItemsItemAddressAddressLine1Max = 255;

export const listSystemTemplatesResponseItemsItemAddressAddressLine2Max = 255;

export const listSystemTemplatesResponseItemsItemAddressCityMax = 255;

export const listSystemTemplatesResponseItemsItemAddressStateMax = 2;

export const listSystemTemplatesResponseItemsItemAddressZipMax = 10;

export const listSystemTemplatesResponseItemsItemAddressCountryMax = 100;



export const listSystemTemplatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid().nullish(),
  "scope": zod.enum(['System', 'Organization', 'Community']),
  "templateName": zod.string().min(1),
  "title": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(listSystemTemplatesResponseItemsItemPayRateValueMin).max(listSystemTemplatesResponseItemsItemPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(listSystemTemplatesResponseItemsItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listSystemTemplatesResponseItemsItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listSystemTemplatesResponseItemsItemAddressCityMax).nullish(),
  "state": zod.string().max(listSystemTemplatesResponseItemsItemAddressStateMax).nullish(),
  "zip": zod.string().max(listSystemTemplatesResponseItemsItemAddressZipMax).nullish(),
  "country": zod.string().max(listSystemTemplatesResponseItemsItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_GET
 */
export const getOpportunityTemplateByIdParams = zod.object({
  "id": zod.string().uuid()
})



export const getOpportunityTemplateByIdResponsePayRateValueMin = 0;
export const getOpportunityTemplateByIdResponsePayRateValueMax = 10000;

export const getOpportunityTemplateByIdResponseAddressAddressLine1Max = 255;

export const getOpportunityTemplateByIdResponseAddressAddressLine2Max = 255;

export const getOpportunityTemplateByIdResponseAddressCityMax = 255;

export const getOpportunityTemplateByIdResponseAddressStateMax = 2;

export const getOpportunityTemplateByIdResponseAddressZipMax = 10;

export const getOpportunityTemplateByIdResponseAddressCountryMax = 100;



export const getOpportunityTemplateByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid().nullish(),
  "scope": zod.enum(['System', 'Organization', 'Community']),
  "templateName": zod.string().min(1),
  "title": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(getOpportunityTemplateByIdResponsePayRateValueMin).max(getOpportunityTemplateByIdResponsePayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(getOpportunityTemplateByIdResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getOpportunityTemplateByIdResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getOpportunityTemplateByIdResponseAddressCityMax).nullish(),
  "state": zod.string().max(getOpportunityTemplateByIdResponseAddressStateMax).nullish(),
  "zip": zod.string().max(getOpportunityTemplateByIdResponseAddressZipMax).nullish(),
  "country": zod.string().max(getOpportunityTemplateByIdResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
})

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_UPDATE
 */
export const updateOpportunityTemplateParams = zod.object({
  "id": zod.string().uuid()
})

export const updateOpportunityTemplateBodyTemplateNameMax = 255;

export const updateOpportunityTemplateBodyTitleMax = 255;

export const updateOpportunityTemplateBodyReferenceRequirementsItemLabelMax = 100;

export const updateOpportunityTemplateBodyReferenceRequirementsItemHintMax = 255;

export const updateOpportunityTemplateBodyReferenceRequirementsItemExampleMax = 100;

export const updateOpportunityTemplateBodyPayRateValueMin = 0;
export const updateOpportunityTemplateBodyPayRateValueMax = 10000;

export const updateOpportunityTemplateBodyNumberOfUnitsMax = 2147483647;

export const updateOpportunityTemplateBodyMaxUnitsPerParticipantMax = 2147483647;

export const updateOpportunityTemplateBodyMaxClaimsPerParticipantMax = 2147483647;

export const updateOpportunityTemplateBodyMaxClaimsPerRosterMax = 2147483647;

export const updateOpportunityTemplateBodyAddressAddressLine1Max = 255;

export const updateOpportunityTemplateBodyAddressAddressLine2Max = 255;

export const updateOpportunityTemplateBodyAddressCityMax = 255;

export const updateOpportunityTemplateBodyAddressStateMax = 2;

export const updateOpportunityTemplateBodyAddressZipMax = 10;

export const updateOpportunityTemplateBodyAddressCountryMax = 100;

export const updateOpportunityTemplateBodyUrlMax = 2048;



export const updateOpportunityTemplateBody = zod.object({
  "templateName": zod.string().min(1).max(updateOpportunityTemplateBodyTemplateNameMax),
  "title": zod.string().max(updateOpportunityTemplateBodyTitleMax).nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "label": zod.string().min(1).max(updateOpportunityTemplateBodyReferenceRequirementsItemLabelMax),
  "masks": zod.array(zod.string()).nullish(),
  "hint": zod.string().max(updateOpportunityTemplateBodyReferenceRequirementsItemHintMax).nullish(),
  "example": zod.string().max(updateOpportunityTemplateBodyReferenceRequirementsItemExampleMax).nullish()
})).nullish(),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(updateOpportunityTemplateBodyPayRateValueMin).max(updateOpportunityTemplateBodyPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().min(1).max(updateOpportunityTemplateBodyNumberOfUnitsMax).nullish(),
  "maxUnitsPerParticipant": zod.number().min(1).max(updateOpportunityTemplateBodyMaxUnitsPerParticipantMax).nullish(),
  "maxClaimsPerParticipant": zod.number().min(1).max(updateOpportunityTemplateBodyMaxClaimsPerParticipantMax).nullish(),
  "maxClaimsPerRoster": zod.number().min(1).max(updateOpportunityTemplateBodyMaxClaimsPerRosterMax).nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateOpportunityTemplateBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateOpportunityTemplateBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateOpportunityTemplateBodyAddressCityMax).nullish(),
  "state": zod.string().max(updateOpportunityTemplateBodyAddressStateMax).nullish(),
  "zip": zod.string().max(updateOpportunityTemplateBodyAddressZipMax).nullish(),
  "country": zod.string().max(updateOpportunityTemplateBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().max(updateOpportunityTemplateBodyUrlMax).nullish(),
  "isActive": zod.boolean()
})



export const updateOpportunityTemplateResponsePayRateValueMin = 0;
export const updateOpportunityTemplateResponsePayRateValueMax = 10000;

export const updateOpportunityTemplateResponseAddressAddressLine1Max = 255;

export const updateOpportunityTemplateResponseAddressAddressLine2Max = 255;

export const updateOpportunityTemplateResponseAddressCityMax = 255;

export const updateOpportunityTemplateResponseAddressStateMax = 2;

export const updateOpportunityTemplateResponseAddressZipMax = 10;

export const updateOpportunityTemplateResponseAddressCountryMax = 100;



export const updateOpportunityTemplateResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid().nullish(),
  "scope": zod.enum(['System', 'Organization', 'Community']),
  "templateName": zod.string().min(1),
  "title": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(updateOpportunityTemplateResponsePayRateValueMin).max(updateOpportunityTemplateResponsePayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateOpportunityTemplateResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateOpportunityTemplateResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateOpportunityTemplateResponseAddressCityMax).nullish(),
  "state": zod.string().max(updateOpportunityTemplateResponseAddressStateMax).nullish(),
  "zip": zod.string().max(updateOpportunityTemplateResponseAddressZipMax).nullish(),
  "country": zod.string().max(updateOpportunityTemplateResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
})

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_DELETE
 */
export const deleteOpportunityTemplateParams = zod.object({
  "id": zod.string().uuid()
})

